import PropTypes from "prop-types";
import { Dropdown } from "primereact/dropdown";
import { getErrorMessage } from "../form/FormStandardProps";
import { useIntl } from "react-intl";
import Label from "./Label";

const DropdownInput = ({
  editable = false,
  input,
  label = "",
  loading = false,
  meta,
  options = [],
  required = false,
  placeholder = "select",
  optionLabel = "name",
  disabled = false,
  filter = false,
  readOnly = false,
  showClear = false,
  style = {},
  value,        // ✅ controlled value
  onChange,     // ✅ controlled change
  ...rest
}) => {
  const { touched, error } = meta || {};
  const inputProps = input || {};

  const intl = useIntl();

  return (
    <div className="edexlms-field dropdown-input" style={{ ...style }}>
      {(label && (
        <Label
          label={label}
          disabled={disabled}
          required={required}
          // htmlFor={input.name}
          htmlFor={input?.name || rest.id}  // ✅ safe fallback
        />
      )) ||
        null}
      <Dropdown
        {...input}
         value={value}                     // ✅ controlled value (0, 1, etc.)
        options={options || []}           // must be objects: { name, value }
        optionLabel="name"                // field to display
        optionValue="value"               // field to match for selected value
        onChange={(e) => onChange?.(e.value)} // updates parent state
        placeholder={intl.formatMessage(
          { id: "dynamic_select" },
          { label: placeholder }
        )}
        showClear={showClear}
        checkmark={true}
        editable={editable}
        filter={filter}
        filterBy={optionLabel}
        loading={loading}
        // optionLabel={optionLabel}
        invalid={touched && error}
        disabled={disabled}
        // placeholder={intl.formatMessage(
        //   { id: "dynamic_select" },
        //   { label: placeholder }
        // )}
        // onChange={(e) => !readOnly && input.onChange(e.value)}
        // onChange={(e) => {
        //   if (!readOnly) {
        //     // input.onChange(e.value);       // updates the form value
        //     // rest.onChange?.(e.value);      // calls your handleLanguageChange
        //                 onChange?.(e.value);   // ✅ call parent handler
                        

        //   }
        // }}

        className={`edexlms-field-input w-full`}
      />
      {(touched && error && (
        <div className="edexlms-field-error">
          {getErrorMessage(error, inputProps, rest, label || placeholder)}
        </div>
      )) ||
        null}
    </div>
  );
};

DropdownInput.propTypes = {
  editable: PropTypes.bool,
  input: PropTypes.object,
  label: PropTypes.string,
  loading: PropTypes.bool,
  meta: PropTypes.object,
  options: PropTypes.array.isRequired,
  placeholder: PropTypes.string,
  required: PropTypes.bool,
  optionLabel: PropTypes.string,
  disabled: PropTypes.bool,
  filter: PropTypes.bool,
   value: PropTypes.any,       // ✅ added
  onChange: PropTypes.func,   // ✅ added
};

export default DropdownInput;
